import React from 'react'
import { CButton, CPopover } from '@coreui/react'
import CIcon from '@coreui/icons-react'
import { cilInfo } from '@coreui/icons'

/**
 * [RGM] 2026-10-01 (pedido Rafael, faltantes-multitema E): botón de INFO ⓘ
 * que describe cómo leer cada gráfica. Mismo formato del botón de descarga
 * (BotonCapturaChart — CButton primary size sm con CIcon) pero OUTLINE (sin
 * fondo). Popover de CoreUI al click (no modal); ocupa el mismo lugar del
 * header, junto al botón de descarga — no mueve el diseño.
 */
const BotonInfoChart: React.FC<{
  titulo: string
  texto: React.ReactNode
  className?: string
}> = ({ titulo, texto, className }) => (
  <CPopover
    trigger="click"
    placement="top"
    title={titulo}
    content={<div className="small" style={{ maxWidth: 300 }}>{texto}</div>}
  >
    <CButton
      color="primary"
      variant="outline"
      size="sm"
      aria-label="Cómo leer la gráfica"
      // Separación MÍNIMA del botón de descarga (pedido Rafael 2026-10-01).
      className={`me-1 ${className ?? ''}`}
    >
      <CIcon icon={cilInfo} />
    </CButton>
  </CPopover>
)

export default BotonInfoChart
